import { ILogger } from '@cian/logger';
import { mergeDeepRight } from 'ramda';

declare global {
  // tslint:disable-next-line: interface-name
  interface Window {
    ca: ICianAnalytics;
  }
}

// tslint:disable-next-line: no-any
type TEventQueueItem = [string, { [key: string]: any }];

interface ICianAnalytics {
  (): void;
  q: TEventQueueItem[];
}

interface IDependencies {
  logger: ILogger;
}

interface IParams {
  pageViewParams: object;
}

/**
 * Модифицирует параметры события pageview на стороне браузера, которое отправляется при перевом рендере страницы.
 * Поскольку объект для события pageview при перевом рендере формируется на ноде, возникают кейсы,
 * когда требуется добавить некоторые параметры на стороне бразуера.
 * Например, если данные параметры хранятся в localStorage/sessionStorage.
 */
export function modifyPageViewAnalyticsEvent({ logger }: IDependencies, { pageViewParams }: IParams) {
  try {
    const eventQueue = window.ca.q;
    const pageViewEvent = eventQueue.find(([eventType, eventParams]) => eventParams.name === 'newpage');

    if (!pageViewEvent) {
      throw new Error('pageview analytics event was not found in the analytics event queue');
    }

    pageViewEvent[1] = mergeDeepRight(pageViewEvent[1], pageViewParams);
  } catch (error) {
    logger.error('pageview analytics event was not modified', {
      domain: 'browser/utils#modifyPageViewAnalyticsEvent()',
    });
  }
}
